import type { AllTableCriteria } from '@openx/types/tableCriteria';
import { useDealPromptDomainsContext } from '../utils/context/DealPromptDomainsContext';
import { type DealPromptContextType, type DealPromptFilters, dealPromptContextTypes } from '../utils/types';

export const useFetchResults = (
  contextType: DealPromptContextType,
  criteria: AllTableCriteria<DealPromptFilters>,
  promptChanged: boolean
) => {
  const {
    useDealPromptAppsSearchFetch,
    useDealPromptDomainSearchFetch,
    useDealPromptAppsSearchExtendedFetch,
    useDealPromptDomainSearchExtendedFetch,
  } = useDealPromptDomainsContext();

  const { fetchDealPromptApps } = useDealPromptAppsSearchFetch(criteria);
  const { fetchDealPromptDomains } = useDealPromptDomainSearchFetch(criteria);
  const { fetchDealPromptAppsExtended } = useDealPromptAppsSearchExtendedFetch(criteria);
  const { fetchDealPromptDomainsExtended } = useDealPromptDomainSearchExtendedFetch(criteria);

  switch (contextType) {
    case dealPromptContextTypes.DOMAINS:
      if (promptChanged) {
        return fetchDealPromptDomainsExtended;
      }

      return fetchDealPromptDomains;
    case dealPromptContextTypes.APPS:
      if (promptChanged) {
        return fetchDealPromptAppsExtended;
      }

      return fetchDealPromptApps;
    case dealPromptContextTypes.AUDIENCE:
      return;
    default:
      throw new Error(`Unsupported context type: ${contextType}`);
  }
};
